module.exports = __webpack_public_path__ + "static/media/upload_success.ec8f7a22.svg";